module.exports = __webpack_public_path__ + "media/images/sp/specials/common/recommend_kobe-7ad1b0aa8c7fa065911b6f726ada5edc.jpg";